//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

/**
 * A display name for a Gallery.
 * e.g. 'Mike's Homepage Gallery'
 *
 * Maps to ReelName in pinsights-entity-model
 */
type GalleryDisplayName = Opaque<string, 'GalleryDisplayName'>;

function GalleryDisplayNameFactory(name: string) {
  return name as GalleryDisplayName;
}

const GalleryDisplayName = GalleryDisplayNameFactory;

export default GalleryDisplayName;
